import calculateDaysUntilExpiration from './calculateDaysUntilExpiration'

const isAutoRenewDisabled = (expirationDate) => {
  return calculateDaysUntilExpiration(expirationDate) <= 0
}

export default isAutoRenewDisabled
